import tippy from "tippy.js";
import "tippy.js/dist/tippy.css";

const applyTooltip = (target, content) => {
  tippy(target, {
    content,
    arrow: false,
    placement: "bottom",
    theme: "oshiruko",
  });
};

applyTooltip(".youtube-link", "YouTube");
applyTooltip(".blog-link", "Blog");
applyTooltip(".x-link", "X (旧 Twitter)");
applyTooltip(".booth-link", "Booth");
applyTooltip(".github-link", "GitHub");
applyTooltip(".zenn-link", "Zenn");
applyTooltip(".huggingface-link", "Hugging Face");

